export default __webpack_public_path__ + "static/media/21.053ee414.jpg";